import { __extends } from "tslib";
import { CreateProjectVersionRequest, CreateProjectVersionResponse } from "../models/index";
import { deserializeAws_json1_1CreateProjectVersionCommand, serializeAws_json1_1CreateProjectVersionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CreateProjectVersionCommand = /** @class */ (function (_super) {
    __extends(CreateProjectVersionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateProjectVersionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CreateProjectVersionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: CreateProjectVersionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: CreateProjectVersionResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateProjectVersionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1CreateProjectVersionCommand(input, context);
    };
    CreateProjectVersionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1CreateProjectVersionCommand(output, context);
    };
    return CreateProjectVersionCommand;
}($Command));
export { CreateProjectVersionCommand };
//# sourceMappingURL=CreateProjectVersionCommand.js.map